import { useNavigate } from 'react-router-dom';
import { useModalStore } from '@/entities/Modal';
import { ResponseError } from '@/shared/api/types';
import { useMutation } from '@tanstack/react-query';
import { useGlobalStore } from '@/entities/GlobalStore';
import { setCookie } from '@/shared/lib/utils/setCookie';
import { authQuery } from '../api/authQuery';
import { useUserStore } from '../model/store/useUserStore';

type Props = {
    onError?: () => void;
    onSuccess?: () => void;
};

export const useAuth = ({ onSuccess, onError }: Props = {}) => {
    const { setSelectedGoalParams } = useGlobalStore();
    const { setUser, setIsAuth, setIsUserLoading, setIsNoData, setIsNoAccess } = useUserStore();
    const { setErrorModalProps } = useModalStore();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: authQuery,
        onMutate: () => {
            setIsUserLoading(true);
        },
        onSuccess: (rawData) => {
            const responseUrl = rawData.request?.responseURL;

            if (responseUrl && responseUrl.includes('realms')) {
                window.location.href = responseUrl;

                return;
            }

            const data = rawData.data;

            setUser(data);
            setSelectedGoalParams({ initialRoomsCount: data.goalRooms, initialSquareMeters: data.goalMeters });
            setIsAuth(true);
            setIsUserLoading(false);
            if (data.userId) {
                setCookie('userId', data.userId, 7);
            }

            onSuccess?.();
        },
        onError: (error: ResponseError) => {
            const errorMessage = error.response.data.details[0] || 'Что-то пошло не так';

            if (errorMessage.includes('Договоры не найдены')) {
                setIsAuth(true);
                setIsNoData(true);
                navigate('/lk');

                return;
            }

            if (errorMessage.includes('Ваш договор находится на стадии оформления')) {
                setIsAuth(true);
                setIsNoAccess(true);
                navigate('/lk');

                return;
            }

            setErrorModalProps({ isOpened: true, title: errorMessage });

            onError?.();
        },
        retry: false,
    });
};
